import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { submitReview } from '../api/client';
import Footer from '../components/Footer';

export default function ReviewPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = searchParams.get('booking_id');
  
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!bookingId) {
      navigate('/error?error=Не указан ID записи&back=/');
    }
  }, [bookingId, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) {
      setError('Пожалуйста, выберите оценку');
      return;
    }
    if (!reviewText.trim()) {
      setError('Пожалуйста, напишите отзыв');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await submitReview({
        booking_id: bookingId,
        rating,
        review_text: reviewText.trim()
      });
      navigate('/confirmation?type=review');
    } catch (err) {
      console.error('Ошибка при отправке отзыва:', err);
      setError('Не удалось отправить отзыв. Пожалуйста, попробуйте позже.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 text-gray-800 relative pb-16">
      <header className="bg-white shadow p-4 sticky top-0 z-10">
        <div className="flex items-center gap-4 max-w-xl mx-auto relative">
          <button
            onClick={() => navigate(-1)}
            className="absolute left-0 text-gray-600 hover:bg-gray-100 rounded-full w-10 h-10 flex items-center justify-center transition"
          >
            ←
          </button>
          <h1 className="text-center flex-grow text-lg font-semibold">Оставить отзыв</h1>
        </div>
      </header>

      <main className="max-w-xl mx-auto px-4 py-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-base font-semibold mb-2">Ваша оценка</label>
            <div className="flex gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setRating(star)}
                  className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl transition ${
                    rating >= star
                      ? 'bg-primary text-white'
                      : 'bg-white text-gray-400 border border-gray-300 hover:border-primary'
                  }`}
                >
                  ★
                </button>
              ))}
            </div>
          </div>

          <div>
            <label htmlFor="review" className="block text-base font-semibold mb-2">
              Ваш отзыв
            </label>
            <textarea
              id="review"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              placeholder="Расскажите о вашем опыте..."
              className="w-full h-32 px-4 py-3 rounded-lg border border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary outline-none resize-none"
            />
          </div>

          {error && (
            <div className="text-red-500 text-sm text-center">{error}</div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full px-4 py-2 bg-secondary text-white rounded-md hover:bg-secondary/90 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Отправка...' : 'Отправить отзыв'}
          </button>
        </form>
      </main>
      <Footer />
    </div>
  );
} 